import React from 'react'

const Manual_yappy_boton_pago = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">InvuPOS - Creación de Botón de Pago</h2>
        <iframe
          src="https://scribehow.com/embed/InvuPOS__Creacion_de_Boton_de_Pago__lWolPhuPSqK2QKIos47Mkw?as=scrollable"
          className="scribe-iframe-general-192"
          width="100%"
          height="4500"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_yappy_boton_pago
